import loadable from "@loadable/component";
import { FLIGHT_DETAILS_INBOUND_ROUTE_PATH, FLIGHT_DETAILS_OUTBOUND_ROUTE_PATH, FLIGHT_DETAILS_ROUTE_PATH, SEARCH_RESULTS_INBOUND_ROUTE_PATH, SEARCH_RESULTS_OUTBOUND_ROUTE_PATH, SEARCH_RESULTS_ROUTE_PATH } from "@flights/constants";
export const PostBookingSeatMap = loadable(() => import("../screens/PostBookingSeatMap.js"));
export const PostBookingSeatMapDesktop = loadable(() => import("../screens/PostBookingSeatMap.desktop.js"));
export const Home = loadable(() => import("../screens/Home.js"));
export const Search = loadable(() => import("../screens/Search.js"));
export const PostBookingFlightDetails = loadable(() => import("../screens/PostBookingFlightDetails.js"));
export const FlightDetails = loadable(() => import("../screens/FlightDetails.js"));
export const FlightDetailsNew = loadable(() => import("../screens/FlightDetails/FlightDetails.new.mobile.js"));
export const CheckoutStart = loadable(() => import("../screens/CheckoutStart/CheckoutStart.mobile.js"));
export const CheckoutTicketType = loadable(() => import("../screens/CheckoutTicketType.js"));
export const CheckoutFare = loadable(() => import("../screens/CheckoutFare.js"));
export const CheckoutPax = loadable(() => import("../screens/CheckoutPax.js"));
export const CheckoutExtras = loadable(() => import("../screens/CheckoutExtras.js"));
export const CheckoutSeatMap = loadable(() => import("../screens/CheckoutSeatMap/CheckoutSeatMap.mobile.js"));
export const CheckoutSirf = loadable(() => import("../screens/CheckoutSirf.js"));
export const CheckoutPayment = loadable(() => import("../screens/CheckoutPayment.js"));
export const CheckoutPriceChange = loadable(() => import("../screens/CheckoutPriceChange.js"));
export const Confirmation = loadable(() => import("../screens/Confirmation.js"));
export const ConfirmationDesktop = loadable(() => import("../screens/Confirmation.desktop.js"));
export const OrderDetails = loadable(() => import("../screens/OrderDetails.js"));
export const OrderDetailsDesktop = loadable(() => import("../screens/OrderDetails.desktop.js"));
export const ChangeFlight = loadable(() => import("../screens/ChangeFlight.js"));
export const ChangeFlightDesktop = loadable(() => import("../screens/ChangeFlight.desktop.js"));
export const RebookFlightSelection = loadable(() => import("../components/elements/RebookFlow/RebookFlightSelectionPage.js"));
export const ChangeFlightConfirmation = loadable(() => import("../screens/ChangeFlightConfirmation.js"));
export const ChangeFlightConfirmationDesktop = loadable(() => import("../screens/ChangeFlightConfirmation.desktop.js"));
export const FindMyBooking = loadable(() => import("../screens/FindMyBooking.js"));
export const FindMyBookingDesktop = loadable(() => import("../screens/FindMyBooking.desktop.js"));
export const RequestRefundMyBookingScreenDesktop = loadable(() => import("../screens/RequestRefundMyBooking/RequestRefundMyBooking.screen.desktop.js"));
export const RequestRefundMyBookingScreenMobile = loadable(() => import("../screens/RequestRefundMyBooking/RequestRefundMyBooking.screen.mobile.js"));
export const PostBookingAddBaggage = loadable(() => import("../screens/PostBookingAddBaggage.js"));
export const PostBookingAddFastTrack = loadable(() => import("../screens/PostBookingAddFastTrack.js"));
export const PostBookingFastTrackConfirmation = loadable(() => import("../screens/PostBookingFastTrackConfirmation.js"));
export const ScheduleChangeRefund = loadable(() => import("../screens/ScheduleChangeRefund.js"));
export const ScheduleChangeAlternative = loadable(() => import("../screens/ScheduleChangeAlternative.js"));
export const ScheduleChangeFeedback = loadable(() => import("../screens/ScheduleChangeFeedback.js"));
export const PostBookingAddBaggageDesktop = loadable(() => import("../screens/PostBookingAddBaggage.desktop.js"));
export const HomeDesktop = loadable(() => import("../screens/Home.desktop.js"));
export const SearchDesktop = loadable(() => import("../screens/Search.desktop.js"));
export const SearchOutboundDesktop = loadable(() => import("../screens/Search.outbound.desktop.js"));
export const SearchInboundDesktop = loadable(() => import("../screens/Search.inbound.desktop.js"));
export const SearchOutboundMobile = loadable(() => import("../screens/Search.outbound.mobile.js"));
export const SearchInboundMobile = loadable(() => import("../screens/Search.inbound.mobile.js"));
export const FlightDetailsDesktop = loadable(() => import("../screens/FlightDetails/FlightDetails.desktop.js"));
export const FlightDetailsNewDesktop = loadable(() => import("../screens/FlightDetails/FlightDetails.new.desktop.js"));
export const CheckoutStartDesktop = loadable(() => import("../screens/CheckoutStart/CheckoutStart.desktop.js"));
export const CheckoutTicketTypeDesktop = loadable(() => import("../screens/CheckoutTicketType.desktop.js"));
export const CheckoutFareDesktop = loadable(() => import("../screens/CheckoutFare.desktop.js"));
export const CheckoutPaxDesktop = loadable(() => import("../screens/CheckoutPax.desktop.js"));
export const CheckoutExtrasDesktop = loadable(() => import("../screens/CheckoutExtras.desktop.js"));
export const CheckoutSeatMapDesktop = loadable(() => import("../screens/CheckoutSeatMap/CheckoutSeatMap.desktop.js"));
export const CheckoutSirfDesktop = loadable(() => import("../screens/CheckoutSirf.desktop.js"));
export const CheckoutPaymentDesktop = loadable(() => import("../screens/CheckoutPayment.desktop.js"));
export const CheckoutPriceChangeDesktop = loadable(() => import("../screens/CheckoutPriceChange.desktop.js"));
export const PostBookingPayment = loadable(() => import("../screens/PostBookingPayment.js"));
export const PostBookingPaymentDesktop = loadable(() => import("../screens/PostBookingPayment.desktop.js"));
export const PostBookingConfirmation = loadable(() => import("../screens/PostBookingConfirmation.js"));
export const PostBookingExtras = loadable(() => import("../screens/PostBookingExtras.js"));
export const PostBookingManageBooking = loadable(() => import("../screens/PostBookingManageBooking.js"));
export const PostBookingConfirmationDesktop = loadable(() => import("../screens/PostBookingConfirmation.desktop.js"));
export const PostBookingCancelOrder = loadable(() => import("../screens/PostBookingCancelOrder.js"));
export const PostBookingCancelOrderDesktop = loadable(() => import("../screens/PostBookingCancelOrder.desktop.js"));
export const AdditionalFlightsTerms = loadable(() => import("../screens/AdditionalFlightsTerms.js"));
export const WebCheckin = loadable(() => import("../screens/WebCheckin.js"));
export const WebCheckinDesktop = loadable(() => import("../screens/WebCheckin.desktop.js"));
export const NotAvailable = loadable(() => import("../screens/NotAvailable.js"));
export const CheckoutPaymentCollection = loadable(() => import("../screens/CheckoutPaymentCollection.js"));
export const CheckoutPaymentCollectionDesktop = loadable(() => import("../screens/CheckoutPaymentCollection.desktop.js"));
export const NotFound = loadable(() => import("../screens/NotFound.js"));
export const NotFoundDesktop = loadable(() => import("../screens/NotFound.desktop.js"));
export const FlyAnywhere = loadable(() => import("../screens/FlyAnywhere/FlyAnywhere.js"));
export const FlyAnywhereDesktop = loadable(() => import("../screens/FlyAnywhere/FlyAnywhere.desktop.js"));
export const Deals = loadable(() => import("../screens/Deals/Deals.js"));
export const DealsDesktop = loadable(() => import("../screens/Deals/Deals.desktop.js"));
export const CheckoutAlternativeFares = loadable(() => import("../screens/CheckoutAlternativeFares.js"));
export const CheckoutAlternativeFaresDesktop = loadable(() => import("../screens/CheckoutAlternativeFares.desktop.js"));
export const Messenger = loadable(() => import("../screens/MessengerPage.js"));
export const MessengerEnded = loadable(() => import("../screens/MessengerEndedPage.js"));
export const CheckoutRyanairConfirmationDesktop = loadable(() => import("../screens/CheckoutRyanairConfirmation/CheckoutRyanairConfirmation.desktop.js"));
export const CheckoutRyanairConfirmationMobile = loadable(() => import("../screens/CheckoutRyanairConfirmation/CheckoutRyanairConfirmation.mobile.js"));
export const CheckoutRyanairConfirmationWebview = loadable(() => import("../screens/CheckoutRyanairConfirmation/CheckoutRyanairConfirmation.webview.js"));
const routeMap = function (props) {
    const { isMobile, isPaymentCollectionPage, isWebview, stateMap, isNewFlightDetailsPage, isNewFlightDetailsDesktopPage } = props;
    const routes = [
        {
            path: "/flights/index.:language?.html",
            component: isMobile ? Home : HomeDesktop,
            name: "home",
            exact: true,
            getInitialState: isMobile ? stateMap?.home : stateMap?.homeDesktop
        },
        {
            path: "/",
            component: isMobile ? Home : HomeDesktop,
            name: "home",
            exact: true,
            getInitialState: isMobile ? stateMap?.home : stateMap?.homeDesktop
        },
        {
            path: "/checkout3/:orderToken",
            component: isMobile ? CheckoutPayment : CheckoutPaymentDesktop,
            name: "checkout-payment",
            exact: true
        },
        {
            path: "/checkout/:flightToken",
            component: CheckoutStart,
            name: "checkout-start",
            exact: true
        },
        {
            path: "/checkout/start/:flightToken",
            component: isMobile ? CheckoutStart : CheckoutStartDesktop,
            name: "checkout-start",
            exact: true
        },
        {
            path: "/checkout/ryanair-confirmation/:token",
            component: isWebview
                ? CheckoutRyanairConfirmationWebview
                : isMobile
                    ? CheckoutRyanairConfirmationMobile
                    : CheckoutRyanairConfirmationDesktop,
            name: "checkout-ryanair-confirmation",
            exact: true
        },
        {
            path: "/checkout/ticket-type/:flightToken/:cartToken",
            component: isMobile ? CheckoutTicketType : CheckoutTicketTypeDesktop,
            name: "checkout-ticket-type",
            exact: true
        },
        {
            path: "/checkout/fare/:flightToken/:cartToken",
            component: isMobile ? CheckoutFare : CheckoutFareDesktop,
            name: "checkout-fare",
            exact: true
        },
        {
            path: "/checkout/fare/:flightToken",
            component: isMobile ? CheckoutFare : CheckoutFareDesktop,
            name: "checkout-fare",
            exact: true
        },
        {
            path: "/checkout/pax/:flightToken/:cartToken",
            component: isMobile ? CheckoutPax : CheckoutPaxDesktop,
            name: "checkout-pax",
            exact: true
        },
        {
            path: "/checkout/extras/:flightToken/:cartToken",
            component: isMobile ? CheckoutExtras : CheckoutExtrasDesktop,
            name: "checkout-extras",
            exact: true
        },
        {
            path: "/checkout/seats/:flightToken/:cartToken",
            component: isMobile ? CheckoutSeatMap : CheckoutSeatMapDesktop,
            name: "checkout-seat-selection",
            exact: true
        },
        {
            path: "/checkout/sirf/:flightToken/:cartToken",
            component: isMobile ? CheckoutSirf : CheckoutSirfDesktop,
            name: "checkout-sirf",
            exact: true
        },
        {
            path: "/checkout/payment/:flightToken/:orderToken",
            component: isMobile ? CheckoutPayment : CheckoutPaymentDesktop,
            name: "checkout-payment",
            exact: true
        },
        {
            path: "/checkout/pricechange/:orderToken",
            component: isMobile ? CheckoutPriceChange : CheckoutPriceChangeDesktop,
            name: "pricechange",
            exact: true
        },
        {
            path: "/checkout/alternativeFares/:flightToken",
            component: isMobile ? CheckoutAlternativeFares : CheckoutAlternativeFaresDesktop,
            name: "alternative-fares",
            exact: true
        },
        {
            path: "/booking/confirmation/:token",
            component: isMobile ? Confirmation : ConfirmationDesktop,
            name: "confirmation",
            exact: true
        },
        {
            path: "/booking/order-details/:token",
            component: isMobile ? OrderDetails : OrderDetailsDesktop,
            name: "pb-order-details",
            exact: true
        },
        {
            path: "/booking/order-details/:token/change-flight-select-bound",
            component: RebookFlightSelection,
            name: "pb-change-flight-select-bound",
            exact: true
        },
        {
            path: "/booking/order-details/:token/change-flight",
            component: isMobile ? ChangeFlight : ChangeFlightDesktop,
            name: "pb-change-flight",
            exact: true
        },
        {
            path: "/booking/order-details/:token/rebook-confirmation",
            component: isMobile ? ChangeFlightConfirmation : ChangeFlightConfirmationDesktop,
            name: "pb-rebook-confirmation",
            exact: true
        },
        {
            path: "/booking/order-details/:token/extras",
            component: PostBookingExtras,
            name: "pb-extras",
            exact: true
        },
        {
            path: "/mybooking",
            component: isMobile ? FindMyBooking : FindMyBookingDesktop,
            name: "pb-find-order",
            exact: true
        },
        {
            path: "/request-refund-my-booking",
            component: isMobile ? RequestRefundMyBookingScreenMobile : RequestRefundMyBookingScreenDesktop,
            name: "pb-request-refund-my-booking",
            exact: true
        },
        {
            path: "/booking/cancel/:orderToken",
            component: isMobile ? PostBookingCancelOrder : PostBookingCancelOrderDesktop,
            name: "pb-cancel-order",
            exact: true
        },
        {
            path: "/booking/order-details/:token/schedule-change-refund",
            component: ScheduleChangeRefund,
            name: "pb-schedule-change-refund",
            exact: true
        },
        {
            path: "/booking/order-details/:token/schedule-change-alternative",
            component: ScheduleChangeAlternative,
            name: "pb-schedule-change-alternative",
            exact: true
        },
        {
            path: "/booking/order-details/:token/schedule-change-feedback",
            component: ScheduleChangeFeedback,
            name: "pb-schedule-change-feedback",
            exact: true
        },
        {
            path: "/booking/flight-details/:token/:bound",
            component: isMobile ? PostBookingFlightDetails : OrderDetailsDesktop,
            name: "pb-flight-details",
            exact: true
        },
        {
            path: "/booking/add-baggage/:token",
            component: isMobile ? PostBookingAddBaggage : PostBookingAddBaggageDesktop,
            name: "pb-add-baggage",
            exact: true
        },
        {
            path: "/booking/add-fast-track/:token",
            component: PostBookingAddFastTrack,
            name: "pb-add-fast-track",
            exact: true
        },
        {
            path: "/booking/add-fast-track/:token/confirmation",
            component: PostBookingFastTrackConfirmation,
            name: "pb-add-fast-track-confirmation",
            exact: true
        },
        {
            path: "/booking/checkout/:token/payment",
            component: isMobile ? PostBookingPayment : PostBookingPaymentDesktop,
            name: "pb-checkout-payment",
            exact: true
        },
        {
            path: "/booking/checkout/:token/confirmation",
            component: isMobile ? PostBookingConfirmation : PostBookingConfirmationDesktop,
            name: "pb-checkout-confirmation",
            exact: true
        },
        {
            path: "/booking/add-seats/:orderToken",
            component: isMobile ? PostBookingSeatMap : PostBookingSeatMapDesktop,
            name: "pb-seatmap",
            exact: true
        },
        {
            path: "/additional-flights-terms",
            component: AdditionalFlightsTerms,
            name: "additional-flights-terms",
            exact: true
        },
        {
            path: "/booking/webcheckin/:orderToken",
            component: isMobile ? WebCheckin : WebCheckinDesktop,
            name: "pb-web-checkin",
            exact: true
        },
        {
            path: "/not-available",
            component: NotAvailable,
            name: "not-available",
            exact: true
        },
        {
            path: "/not-found",
            component: isMobile ? NotFound : NotFoundDesktop,
            name: "not-found",
            exact: true
        },
        {
            path: "/fly-anywhere",
            component: isMobile ? FlyAnywhere : FlyAnywhereDesktop,
            name: "fly-anywhere",
            exact: true,
            getInitialState: stateMap?.flyAnywhere
        },
        {
            path: "/deals",
            component: isMobile ? Deals : DealsDesktop,
            name: "deals",
            exact: true,
            getInitialState: stateMap?.deals
        },
        {
            path: "/messenger/:orderToken/ended",
            component: MessengerEnded,
            name: "messenger-ended",
            exact: true
        },
        {
            path: "/messenger/:orderToken",
            component: Messenger,
            name: "messenger",
            exact: true
        }
    ];
    if (isPaymentCollectionPage) {
        routes.push({
            path: "/checkout-collection/:orderToken",
            component: isMobile ? CheckoutPaymentCollection : CheckoutPaymentCollectionDesktop,
            name: "checkout-collection",
            exact: true
        });
    }
    if (isMobile) {
        routes.push({
            path: FLIGHT_DETAILS_OUTBOUND_ROUTE_PATH,
            component: FlightDetails,
            name: "flightdetails-outbound",
            exact: true,
            getInitialState: stateMap?.search
        });
        routes.push({
            path: FLIGHT_DETAILS_INBOUND_ROUTE_PATH,
            component: FlightDetails,
            name: "flightdetails-inbound",
            exact: true,
            getInitialState: stateMap?.search
        });
        routes.push({
            path: SEARCH_RESULTS_OUTBOUND_ROUTE_PATH,
            component: SearchOutboundMobile,
            name: "searchresults-outbound",
            exact: true,
            getInitialState: stateMap?.search
        });
        routes.push({
            path: SEARCH_RESULTS_INBOUND_ROUTE_PATH,
            component: SearchInboundMobile,
            name: "searchresults-inbound",
            exact: true,
            getInitialState: stateMap?.search
        });
        routes.push({
            path: FLIGHT_DETAILS_ROUTE_PATH,
            component: isNewFlightDetailsPage ? FlightDetailsNew : FlightDetails,
            name: "flightdetails",
            exact: true,
            getInitialState: stateMap?.search
        });
        routes.push({
            path: SEARCH_RESULTS_ROUTE_PATH,
            component: Search,
            name: "searchresults",
            exact: true,
            getInitialState: stateMap?.search
        });
        routes.push({
            path: "/booking/order-details/:token/manage-booking",
            component: PostBookingManageBooking,
            name: "pb-manage-booking",
            exact: true
        });
    }
    else {
        routes.push({
            path: FLIGHT_DETAILS_OUTBOUND_ROUTE_PATH,
            component: FlightDetailsDesktop,
            name: "flightdetails-outbound",
            exclude: true,
            exact: true
        });
        routes.push({
            path: FLIGHT_DETAILS_INBOUND_ROUTE_PATH,
            component: FlightDetailsDesktop,
            name: "flightdetails-inbound",
            exclude: true,
            exact: true
        });
        routes.push({
            path: SEARCH_RESULTS_OUTBOUND_ROUTE_PATH,
            component: SearchOutboundDesktop,
            name: "searchresults-outbound",
            exact: false,
            getInitialState: stateMap?.search
        });
        routes.push({
            path: SEARCH_RESULTS_INBOUND_ROUTE_PATH,
            component: SearchInboundDesktop,
            name: "searchresults-inbound",
            exact: false,
            getInitialState: stateMap?.search
        });
        routes.push({
            path: FLIGHT_DETAILS_ROUTE_PATH,
            component: isNewFlightDetailsDesktopPage ? FlightDetailsNewDesktop : FlightDetailsDesktop,
            name: "flightdetails",
            exclude: true,
            exact: true
        });
        routes.push({
            path: SEARCH_RESULTS_ROUTE_PATH,
            component: SearchDesktop,
            name: "searchresults",
            exact: false,
            getInitialState: stateMap?.search
        });
    }
    return routes;
};
const doesRouteNameExist = function (props) {
    const { isMobile, routeName, isPaymentCollectionPage, isWebview, isNewFlightDetailsPage, isNewFlightDetailsDesktopPage } = props;
    return routeMap({
        isMobile,
        isNewFlightDetailsPage,
        isNewFlightDetailsDesktopPage,
        isPaymentCollectionPage,
        isWebview
    }).some((route) => route.name === routeName);
};
export default routeMap;
export { doesRouteNameExist, FLIGHT_DETAILS_ROUTE_PATH, SEARCH_RESULTS_ROUTE_PATH };
